import Icons from "../../../../resources/icons/Icons";
import CustomMenu from "../../../../components/UI/Menus/CustomMenu/CustomMenu";
import { MenuItemEntity } from "../../../../entities/UIEntities/MenuItem";
import { MENU_ITEMS, INPUTS_PROPS } from "../../../../enums/Enums";
import Strings from "../../../../resources/Strings";
import classes from "./AllocationCard.module.css";
import RoundImage from "../../Avatar/RoundImage";
import ScanFobInput from "../../Inputs/ScanWithFobsInputs/ScanFobInput";
import { useEffect, useRef } from "react";
import { Button } from "@mui/material";

const AllocationCard = (props) => {
  const isFobsSupported = props.site.isFobsSupported;
  const isActivateFobMenuItem = !props?.isActive;
  const scanFobInputRef = useRef();

  const activationMenuTitle = () => {
    if (isActivateFobMenuItem && isFobsSupported) {
      return MENU_ITEMS.ACTIVATE_ALLOCATION // MENU_ITEMS.ACTIVATE_FOB;
    }
    if (!isActivateFobMenuItem && isFobsSupported) {
      return MENU_ITEMS.DEACTIVATE_ALLOCATION; // MENU_ITEMS.DEACTIVATE_FOB;
    }
    if (isActivateFobMenuItem && !isFobsSupported) {
      return MENU_ITEMS.ACTIVATE_ALLOCATION;
    }
    if (!isActivateFobMenuItem && !isFobsSupported) {
      return MENU_ITEMS.DEACTIVATE_ALLOCATION;
    }
  };

  useEffect(() => {
    if (props?.showFobScannerInput) {
      // focus in case autoFocus fails on TextInput
      scanFobInputRef?.current?.inputRef?.current?.textFieldInputRef?.current?.focus();
    }

  }, [props?.showFobScannerInput]);

  const fobMenuItems = [
    // first make a check if fob exists && switch to activate / deactivate
    new MenuItemEntity(
      activationMenuTitle(), 
      () => props.openFobActivationModal(props.tokenId),
      true,
      isActivateFobMenuItem ? Icons.MY_PROFILE : Icons.DISACTIVE_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.EDIT_KEY_FOB,
      () => props.targetAllocation(props.tokenId),
      true,
      Icons.EDIT_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.REMOVE_PARKER_ALLOCATION,
      () => props.openRemoveParkerAllocationModal(props.tokenId),
      true,
      Icons.DELETE_ITEM,
      false,
      props
    ),
  ];

  const menuItems = [
    // regular menu items
    new MenuItemEntity(
      activationMenuTitle(),
      () => props.openFobActivationModal(props.tokenId),
      true,
      isActivateFobMenuItem ? Icons.MY_PROFILE : Icons.DISACTIVE_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.REMOVE_PARKER_ALLOCATION,
      () => props.openRemoveParkerAllocationModal(props.tokenId),
      true,
      Icons.DELETE_ITEM,
      false,
      props
    ),
  ];

  // used in allocation - assigned parkers & fobs list
  const handleDelete = () => {
    props.handleDeleteAssignedParker(props.parker.utronUser.id);
  }

  return (
    <>
      <div className={isActivateFobMenuItem ? [classes.allocationContainer, classes.disable].join(' ') : classes.allocationContainer}>
        <div className={classes.leftAllocation}>
          <RoundImage {...props}></RoundImage>
          <div className={classes.textContainer}>
            <span className={classes.name}>{props.name}</span>
            <span className={classes.fob}>
              {props.fob ? `${Strings.FOB} ${props.fob}` : ""}
            </span>
          </div>
        </div>
        {props.showMenuItems && (
          <div className={classes.rightAllocation}>
          <div>
            <CustomMenu menuItems={isFobsSupported ? fobMenuItems : menuItems /*fobMenuItems*/}></CustomMenu>
          </div>
        </div>
        )}
        {props.showDeleteAction && (
          <div className={classes.rightAllocation}>
          <div>
          <Button onClick={handleDelete}>
              <img src={Icons.DELETE_ITEM_4} />
          </Button>
          </div>
        </div>
        )}
      </div>
      {props?.showFobScannerInput && 
      <ScanFobInput 
        label={Strings.SCAN_NEW_FOB_BUTTON}
        id={INPUTS_PROPS.FOB}
        value={props.fobInputValue}
        onChange={props.handleChange}
        handleClose={() => props.handleCloseFobInput(props.tokenId)}
        handleConfirmScanFob={props.handleConfirmScanFob}
        handleResetFob={props.handleResetFob}
        ref={scanFobInputRef}
        //handleSkip={handleSkip}
        //isStepSubmitted={props.isStepSubmitted}
        //handleError={false}
        //hasError={false}
        //errorMessage=""
        //hasError={hasLocalErrors}
        //errorMessage={hasLocalErrors ? Strings.INPUT_ERROR_MESSAGES.FOB_ALREADY_EXISTS : ""}
      />}
    </>
  );
};

export default AllocationCard;
